import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ListItemIcon } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { Link } from "react-router-dom";
import IntegrationIcon from "./IntegrationIcon";
import { IntegrationType } from "./integrationApi";

export default function IntegrationCreateMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        variant="contained"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
      >
        Add Integration
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          component={Link}
          to={`create?type=${IntegrationType.GoogleDrive}`}
          onClick={handleClose}
        >
          <ListItemIcon>
            <IntegrationIcon type={IntegrationType.GoogleDrive} />
          </ListItemIcon>
          Google Drive
        </MenuItem>
        <MenuItem
          component={Link}
          to={`create?type=${IntegrationType.OneDrive}`}
          onClick={handleClose}
        >
          <ListItemIcon>
            <IntegrationIcon type={IntegrationType.OneDrive} />
          </ListItemIcon>
          One Drive
        </MenuItem>
        <MenuItem
          component={Link}
          to={`create?type=${IntegrationType.Dropbox}`}
          onClick={handleClose}
        >
          <ListItemIcon>
            <IntegrationIcon type={IntegrationType.Dropbox} />
          </ListItemIcon>
          DropBox
        </MenuItem>
        <MenuItem
          component={Link}
          to={`create?type=${IntegrationType.MailChimp}`}
          onClick={handleClose}
        >
          <ListItemIcon>
            <IntegrationIcon type={IntegrationType.MailChimp} />
          </ListItemIcon>
          Mail Chimp
        </MenuItem>
        <MenuItem
          component={Link}
          to={`create?type=${IntegrationType.Email}`}
          onClick={handleClose}
        >
          <ListItemIcon>
            <IntegrationIcon type={IntegrationType.Email} />
          </ListItemIcon>
          Email
        </MenuItem>
        <MenuItem
          component={Link}
          to={`create?type=${IntegrationType.Smtp}`}
          onClick={handleClose}
        >
          <ListItemIcon>
            <IntegrationIcon type={IntegrationType.Smtp} />
          </ListItemIcon>
          SMTP Server
        </MenuItem>
        <MenuItem
          component={Link}
          to={`create?type=${IntegrationType.Ftp}`}
          onClick={handleClose}
        >
          <ListItemIcon>
            <IntegrationIcon type={IntegrationType.Ftp} />
          </ListItemIcon>
          FTP Server
        </MenuItem>
      </Menu>
    </div>
  );
}
